

















import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class XsyxHomeFa extends mixins(WeMixin) {
  protected created() {
    console.log(
      process.env.VUE_APP_BASE +
        "/main/coupon/getCouponResult498?a=" +
        "32059008" +
        "&b=" +
        "19951792726" +
        "&c=" +
        "40" +
        "&d=" +
        "20221252345433908" +
        "&e=" +
        "ouykU59nyfTkvb_zuMQft2453afAhE&"
    );
  }

  protected toGetCoupon() {
    window.location.href =
      process.env.VUE_APP_BASE +
      "/main/coupon/getCouponResult498?a=" +
      "32059008" +
      "&b=" +
      "19951792726" +
      "&c=" +
      "40" +
      "&d=" +
      "20221252345433908" +
      "&e=" +
      "ouykU59nyfTkvb_zuMQft2453afAhE&";
    // this.$router.push(
    //   "/main/coupon/getCoupon/" +
    //     "32059008" +
    //     "&" +
    //     "19951792726" +
    //     "&" +
    //     "40" +
    //     "&" +
    //     "20221111172433908"
    // );
  }
}
